import { SpecialRow } from "../legacy/specials";
import { getAllProductsForSpecial } from "../client";
import { useQuery } from "@tanstack/react-query";

/**
 * Returns all products for a special.
 */
export function useProductsForSpecial(special: SpecialRow | null) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["specials", special?.id, "products"],
    queryFn: () => {
      if (!special?.requires_purchase) {
        return [];
      }
      return getAllProductsForSpecial(special.id);
    },
  });

  return { products: data, isLoading, error };
}
